import { CreditcardRegistrationDependencies } from '@/models/payment/creditcard/service/register-new-creditcard'
import { CreditcardServiceForPurchase } from '@/services/api/creditcard'
import {
  CreditcardServiceForSubscription
} from '@/services/api/subscription/payment/creditcard-service-for-subscription'
import { PagePath, WithTitle } from '@spa/components/pages/order/model/context/order-context'
import { LoadPayload } from '@spa/store/modules/creditcard/actions'
import { RootState } from '@spa/store/types'
import { Store } from 'vuex'

export type ContextToRegisterNewCreditCard =
  WithTitle
  & { path: Pick<PagePath, 'editPayment'> }
  & CreditcardRegistrationDependencies

export type ReloadCreditcard = (store: Store<RootState>) => Promise<void>
export const reloadCreditcardForPurchase: ReloadCreditcard = (store) => {
  const payload: LoadPayload = {
    force: true,
    service: new CreditcardServiceForPurchase(),
  }

  return store.dispatch('creditcard/load', payload)
}
export const reloadCreditcardForSubscription: ReloadCreditcard = (store) => {
  const payload: LoadPayload = {
    force: true,
    service: new CreditcardServiceForSubscription(),
  }

  return store.dispatch('creditcard/load', payload)
}
